import { createTheme } from '@mui/material/styles';

export const v3Theme = createTheme({
  palette: {
    mode: 'dark',
    primary:    { main: '#76c442', dark: '#559e2e', light: '#96d866', contrastText: '#000' },
    secondary:  { main: '#34d058', contrastText: '#000' },
    success:    { main: '#22c55e' },
    warning:    { main: '#f59e0b' },
    error:      { main: '#ef4444' },
    info:       { main: '#38bdf8' },
    background: { default: '#060d07', paper: 'rgba(15,28,15,0.85)' },
    divider:    'rgba(118,196,66,0.12)',
    text:       { primary: 'rgba(255,255,255,0.92)', secondary: 'rgba(255,255,255,0.5)' },
  },
  typography: {
    fontFamily: '"Inter","Roboto","Helvetica Neue",sans-serif',
    h1: { fontWeight: 800 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 700 },
    h4: { fontWeight: 600 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    subtitle1: { fontWeight: 500 },
    subtitle2: { fontWeight: 500 },
    button: { fontWeight: 600, textTransform: 'none', letterSpacing: '0.01em' },
  },
  shape: { borderRadius: 14 },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          background: '#060d07',
          scrollbarWidth: 'thin',
          scrollbarColor: 'rgba(118,196,66,0.3) transparent',
          '&::-webkit-scrollbar': { width: 6 },
          '&::-webkit-scrollbar-track': { background: 'transparent' },
          '&::-webkit-scrollbar-thumb': {
            background: 'rgba(118,196,66,0.3)',
            borderRadius: 3,
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          backgroundColor: 'rgba(15,28,15,0.7)',
          border: '1px solid rgba(255,255,255,0.07)',
          backdropFilter: 'blur(16px)',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          backgroundColor: 'rgba(15,28,15,0.7)',
          border: '1px solid rgba(255,255,255,0.07)',
          backdropFilter: 'blur(16px)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 10, textTransform: 'none', fontWeight: 600 },
        containedPrimary: {
          background: 'linear-gradient(135deg,#76c442 0%,#559e2e 100%)',
          boxShadow: '0 4px 16px rgba(118,196,66,0.3)',
          '&:hover': {
            background: 'linear-gradient(135deg,#8dd55a 0%,#65ae3e 100%)',
            boxShadow: '0 6px 20px rgba(118,196,66,0.45)',
          },
        },
        outlinedPrimary: {
          borderColor: 'rgba(118,196,66,0.5)',
          '&:hover': { borderColor: '#76c442', background: 'rgba(118,196,66,0.08)' },
        },
      },
    },
    MuiChip: {
      styleOverrides: { root: { borderRadius: 8, fontWeight: 600 } },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            '& fieldset': { borderColor: 'rgba(255,255,255,0.12)' },
            '&:hover fieldset': { borderColor: 'rgba(118,196,66,0.4)' },
            '&.Mui-focused fieldset': { borderColor: '#76c442' },
          },
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          '&.Mui-selected': {
            backgroundColor: 'rgba(118,196,66,0.15)',
            '&:hover': { backgroundColor: 'rgba(118,196,66,0.2)' },
          },
          '&:hover': { backgroundColor: 'rgba(255,255,255,0.05)' },
        },
      },
    },
    MuiDivider: {
      styleOverrides: { root: { borderColor: 'rgba(255,255,255,0.07)' } },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: 'rgba(15,28,15,0.95)',
          border: '1px solid rgba(118,196,66,0.2)',
          fontSize: '0.75rem',
        },
      },
    },
  },
});
